const getters = {
    entities: (state) => state.entities,
    selectedEntity: (state) => state.selectedEntity,
    isEntitiesWithAttributesLoaded: state => state.isEntitiesWithAttributesLoaded
}
export default getters;